<template>
    <div>
        <el-card class="box-card">
            <el-container>
                <el-aside>
                    <el-tree 
                        ref="tree"
                        :data="data" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick"
                        node-key="id"
                        :default-expanded-keys="[0]"
                        :default-checked-keys="[1]"></el-tree>    
                </el-aside>
                <el-main>
                    <template>
                        <el-checkbox-group 
                            v-model="checkedItems">
                            <el-row v-for="(item,index) in items" :key="index" >
                                <el-col :span="6" v-for="(e,i) in item" :key="i">
                                    <el-checkbox :label="e.column_COMMENT">{{e.column_COMMENT}}</el-checkbox>
                                </el-col>
                            </el-row>
                        </el-checkbox-group>
                    </template>
                    <el-row type="flex" justify="center" style="margin-top:20px">
                        <el-button type="primary" icon="el-icon-check" size="mini" @click="savedata">保存</el-button>
                        <el-button type="primary" icon="el-icon-close" size="mini" @click="back">返回</el-button>
                    </el-row>
                </el-main>
            </el-container>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data:[
                    {
                        id:0,
                        label:'学生信息',
                        children:[
                            {
                                id:1,
                                label:'基本信息'
                            },
                            // {
                            //     label:'党团信息'
                            // },
                            {
                                id:3,
                                label:'入学信息'
                            },
                            {
                                id:2,
                                label:'学籍信息'
                            }
                            // {
                            //     label:'资助信息'
                            // },
                            // {
                            //     label:'测评信息'
                            // }
                        ]
                    }
                ],
                defaultProps:{
                    children: 'children',
                    label: 'label'
                },
                checkedItems:[],//选中项
                items:[],//初始化选框
                list:[],//所有项
                id:1//当前树
            }
        },
        methods: {
            handleNodeClick(data){
                // console.log(data);
                if(data.id){
                    this.id=data.id;
                    this.onLoad(data.id.toString());
                }

            },
            onLoad(num){
                this.$http.post("/conditionLibrary/getConditionLibrary",null,{
                    params:{
                        tableName:num
                    }
                }).then(res=>{
                    let result = [];
                    let chunk = 4;
                    // console.log(res);
                    this.list=res.data;
                    for (let i = 0, j = res.data.length; i < j; i += chunk) {
                        result.push(res.data.slice(i, i + chunk));
                    }
                    this.items=result;
                    let arr=res.data.filter(e=>{
                        return e.type==="1"
                    })
                    let arr2=[]
                    arr.forEach(e=>{
                        arr2.push(e.column_COMMENT)
                    })
                    this.checkedItems=arr2;
                    // console.log(this.checkedItems);
                }).catch(error=>{
                    this.$message.error(error.msg);
                })
            },
            savedata(){
                let checkedItems=this.checkedItems;
                let mix = this.list.filter(function(item){
                    return checkedItems.indexOf(item.column_COMMENT) != -1
                });
                // console.log(mix)
                mix=mix.map(e=>{                    
                    e.tableClomn=e.column_NAME
                    e.clomnRemark=e.column_COMMENT
                    // e.tableName=this.id.toString()
                    delete e.column_NAME;
                    delete e.column_COMMENT;
                    delete e.data_TYPE;
                    delete e.type;
                    delete e.column_TYPE;
                    return e                    
                })
                // console.log(mix);
                            
                this.$http.post("/conditionLibrary/update",mix,{
                    params:{tableName:this.id.toString()}
                }).then(res=>{
                    // console.log(res);
                    this.$message.success('保存成功')
                }).catch(error=>{
                    this.$message.error(error.msg);
                })
            },
            // 返回
            back(){
                this.$router.push({name:'首页'})
            }
        },
        mounted() {
            this.onLoad("1");
            this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(1); //默认基本信息高亮
            })
        },
    }
</script>

<style lang="scss" scoped>

</style>